/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cli_Tools_MenuInputs */



/**
* | output |
* | --- |
* | "CLI Tools menu" |
*
* @param {Cli_Tools_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cli_tools_menu = /** @type {((inputs?: Cli_Tools_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cli_Tools_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu outils CLI")
	if (locale === "de") return /** @type {LocalizedString} */ ("CLI-Tools-Menü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Menu Strumenti CLI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Меню «Инструменты» командной строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú Herramientas CLI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CLI 工具菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CLIツールメニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CLI टूल्स मेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Menu de ferramentas CLI")
	return /** @type {LocalizedString} */ ("CLI Tools menu")
});